/* Bravotex domain routing. Liquid is the only source of the active shop. */
(function () {
  'use strict';
  var cfg = window.BravotexShopContext;
  // bravotex-domain-redirect already forwards to the correct shop domain.
  if (!cfg || !cfg.context || window.BravotexRedirecting) return;

  var origin = window.location.origin;
  var root = (cfg.rootUrl || '/').replace(/\/+$/, '');
  var home = root + '/';
  var shopHosts = {
    'ass.bravotex-shop.at': 'ass',
    'mst.bravotex-shop.at': 'mst',
    'sc.bravotex-shop.at': 'sc',
    'vsv.bravotex-shop.at': 'vsv',
    'hjt.bravotex-shop.at': 'hjt',
    'spg-rinn-tulfes.bravotex-shop.at': 'spg-rinn-tulfes',
    'ecg.bravotex-shop.at': 'ecg'
  };

  function localPath(path) {
    var cleaned = path.replace(/\/+$/, '') || '/';
    if (root && (cleaned === root || cleaned.indexOf(root + '/') === 0)) {
      cleaned = cleaned.slice(root.length) || '/';
    }
    return cleaned;
  }

  function handleContext(value) {
    var handle;
    try { handle = decodeURIComponent(value).toLowerCase(); }
    catch (error) { handle = value.toLowerCase(); }
    if (cfg.mainCollectionHandle && handle === cfg.mainCollectionHandle.toLowerCase()) return cfg.context;
    if (/^(ass)(-|$)/.test(handle) || /auto-?sport-seefeld/.test(handle)) return 'ass';
    if (/^(mst)(-|$)/.test(handle) || /motorsporttage/.test(handle)) return 'mst';
    if (/^(sc)(-|$)/.test(handle) || /seefeld-classic|classic-cars|classiccars/.test(handle)) return 'sc';
    if (/^(vsv)(-|$)/.test(handle) || /voelser-sv|volser-sv|völser-sv/.test(handle)) return 'vsv';
    if (/^(hjt)(-|$)/.test(handle) || /haflinger/.test(handle)) return 'hjt';
    if (/^(spg-rinn-tulfes)(-|$)/.test(handle) || /rinn-tulfes/.test(handle)) return 'spg-rinn-tulfes';
    if (/^(ecg)(-|$)/.test(handle) || /ec-goe?tzens|ec-götzens/.test(handle)) return 'ecg';
    return '';
  }

  function localCollectionPath(value) {
    if (!value) return '';
    try {
      var path = new URL(value, origin).pathname;
      if (root && path.indexOf(root + '/') !== 0) path = root + path;
      return path;
    } catch (error) { return ''; }
  }

  var targetCollection = localCollectionPath(cfg.collectionUrl);
  var currentPath = localPath(window.location.pathname);
  var legacyVsvMain = /^\/collections\/(vsv|volser-sv|voelser-sv)$/.test(currentPath);

  function replaceTo(target, clearQuery) {
    if (!target || cfg.designMode) return false;
    var current = window.location.pathname.replace(/\/+$/, '') || '/';
    var next = target.replace(/\/+$/, '') || '/';
    if (current === next) return false;
    var params = new URLSearchParams(window.location.search);
    ['page', 'sort_by', 'view', 'section_id', 'sections', 'sections_url'].forEach(function (key) { params.delete(key); });
    Array.from(params.keys()).forEach(function (key) { if (key.indexOf('filter.') === 0) params.delete(key); });
    if (clearQuery) params.delete('q');
    var query = params.toString();
    window.location.replace(target + (query ? '?' + query : '') + window.location.hash);
    return true;
  }

  // General contact/policy/account/cart URLs are deliberately not redirected.
  if (currentPath === '/collections' || currentPath === '/collections/all') {
    if (replaceTo(targetCollection || home, true)) return;
  } else if (cfg.context === 'vsv' && legacyVsvMain && targetCollection) {
    if (replaceTo(targetCollection, true)) return;
  } else if (cfg.pageAllowed === 'false') {
    var isProductOrCollection = /^\/(products|collections)(\/|$)/.test(currentPath);
    if (replaceTo(isProductOrCollection ? (targetCollection || home) : home, true)) return;
  }

  // Preserve same-shop navigation on the current alias, including new AJAX markup.
  function updateLink(link) {
    var raw = link.getAttribute('href');
    if (!raw || /^(#|mailto:|tel:|javascript:)/i.test(raw)) return;
    var url;
    try { url = new URL(raw, origin); } catch (error) { return; }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    var host = url.hostname.toLowerCase();
    var explicitContext = shopHosts[host];
    var isSameShop = url.origin === origin || host === cfg.primaryHost || host === cfg.platformHost || explicitContext;
    if (!isSameShop) return;
    var path = localPath(url.pathname);
    // Do not rewrite hosted customer-account, checkout or app endpoints.
    if (/^\/(account|checkout|checkouts|apps|a|admin)(\/|$)/.test(path)) return;
    var match = path.match(/^\/(collections|pages)\/([^/]+)/);
    var resourceContext = match ? handleContext(match[2]) : '';
    if ((explicitContext && explicitContext !== cfg.context) || (resourceContext && resourceContext !== cfg.context)) {
      // Hide the link, not a surrounding card that might contain unrelated content.
      link.setAttribute('data-bravotex-hidden', 'true');
      return;
    }
    if (path === '/collections' || path === '/collections/all' || (cfg.context === 'vsv' && /^\/collections\/(vsv|volser-sv|voelser-sv)$/.test(path))) {
      url.pathname = targetCollection || home;
    }
    var href = url.pathname + url.search + url.hash;
    if (raw !== href) link.setAttribute('href', href);
  }

  function updateLinks(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches('a[href]')) updateLink(node);
    node.querySelectorAll('a[href]').forEach(updateLink);
  }

  function ready() {
    document.documentElement.setAttribute('data-bravotex-context', cfg.context);
    if (document.body) {
      document.body.setAttribute('data-bravotex-context', cfg.context);
      document.body.classList.add('bravotex-context-' + cfg.context);
      if (cfg.collectionHandle) document.body.classList.add('bravotex-collection-' + cfg.collectionHandle.replace(/[^a-z0-9_-]/gi, '-'));
      updateLinks(document.body);
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(updateLinks);
          if (record.type === 'attributes') updateLinks(record.target);
        });
      }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
    }
    if (cfg.collectionHandle === 'mst') {
      document.querySelectorAll('main h1').forEach(function (heading) {
        if ((heading.textContent || '').trim().toLowerCase() === 'mst') heading.textContent = 'Motorsporttage Shop';
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
